import { Trans } from "react-i18next";

import { Message } from "@aviary/components/Message/Message";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";
import { type State } from "@shared/types/graphqlGenerated";

interface Props {
  containsCbd: boolean;
  stateRestricted: State[];
}

const StateRestrictionWarning = ({ stateRestricted, containsCbd }: Props) => {
  const { isEmerson, isUnauthenticated } = useSharedGlobalConfig();

  if (!isEmerson || !stateRestricted?.length || !containsCbd || isUnauthenticated) return null;

  const stateList = stateRestricted.map(state => state.abbr).join(", ");

  return (
    <Message isColor="warning" data-testid="state-restriction">
      <Trans i18nKey={l.cbd.stateRestriction} values={{ states: stateList }} />
    </Message>
  );
};

export { StateRestrictionWarning };
